package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.theme.WebType
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.OnSurfaceMuted
import com.merkost.handpass.sharedweb.theme.PadLg
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun AdminPageHeader(
    title: String,
    subtitle: String? = null,
    actions: (@Composable () -> Unit)? = null,
) {
    Div(
        attrs = Modifier
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .styleModifier {
                property("justify-content", "space-between")
                property("flex-wrap", "wrap")
                property("gap", "16px")
                property("margin-bottom", "${PadLg.value()}")
            }
            .toAttrs()
    ) {
        Div(
            attrs = Modifier
                .display(DisplayStyle.Flex)
                .flexDirection(FlexDirection.Column)
                .styleModifier { property("min-width", "0") }
                .toAttrs()
        ) {
            H1(
                attrs = Modifier
                    .color(OnSurface.value())
                    .fontSize(WebType.H1)
                    .fontWeight(700)
                    .styleModifier {
                        property("margin", "0")
                        property("letter-spacing", "-0.02em")
                    }
                    .toAttrs()
            ) { Text(title) }
            if (subtitle != null) {
                Span(
                    attrs = Modifier
                        .color(OnSurfaceMuted.value())
                        .fontSize(WebType.Body)
                        .styleModifier { property("margin-top", "4px") }
                        .toAttrs()
                ) { Text(subtitle) }
            }
        }
        if (actions != null) {
            Div(
                attrs = Modifier
                    .display(DisplayStyle.Flex)
                    .alignItems(AlignItems.Center)
                    .gap(10.px)
                    .styleModifier {
                        property("flex-wrap", "wrap")
                        property("justify-content", "flex-end")
                    }
                    .toAttrs()
            ) { actions() }
        }
    }
}
